import { WaitOnBankAccountAnalysisCompletionViaPolling } from '@core/gateway/notification/bankAccountAnalysisCompletion/waitOnBankAccountAnalysisCompletionViaPolling';
import { WaitOnCaseStateNotificationViaPolling } from '@core/gateway/notification/caseState/waitOnCaseStateNotificationViaPolling';
import { WaitOnWebauthNotificationViaPolling } from '@core/gateway/notification/webauth/waitOnWebauthNotificationViaPolling';
import type { Logger } from '@core/model/domain/logger';
import { WaitOnBankAccountAnalysisCompletionGateway } from '@core/model/gateway/waitOnBankAccountAnalysisCompletionGateway';
import { WaitOnCaseStateNotificationGateway } from '@core/model/gateway/waitOnCaseStateNotificationGateway';
import { WaitOnWebauthNotificationGateway } from '@core/model/gateway/waitOnWebauthNotificationGateway';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

@injectable()
export class NotificationSwitcher {
  private notificationMethodToUse: 'POLLING' | 'SIGNAL_R' | 'NONE' = 'NONE';

  constructor(
    @inject(SERVICE_ID.logger)
    private logger: Logger,
    @inject(WaitOnCaseStateNotificationViaPolling)
    private waitOnCaseStateNotificationViaPolling: WaitOnCaseStateNotificationViaPolling,
    @inject(WaitOnWebauthNotificationViaPolling)
    private waitOnWebauthNotificationViaPolling: WaitOnWebauthNotificationViaPolling,
    @inject(WaitOnBankAccountAnalysisCompletionViaPolling)
    private waitOnBankAccountAnalysisCompletionViaPolling: WaitOnBankAccountAnalysisCompletionViaPolling
  ) {}

  async initialize() {
    this.notificationMethodToUse = 'POLLING';
    this.logger.logTrace(`Notification method used: ${this.notificationMethodToUse}`);
  }

  getWaitOnCaseStateNotificationGateway(): WaitOnCaseStateNotificationGateway {
    if (this.notificationMethodToUse === 'POLLING') {
      return this.waitOnCaseStateNotificationViaPolling;
    }

    throw new Error('There is no other notification method than Polling');
  }

  getWaitOnWebauthNotificationGateway(): WaitOnWebauthNotificationGateway {
    if (this.notificationMethodToUse === 'POLLING') {
      return this.waitOnWebauthNotificationViaPolling;
    }

    throw new Error('There is no other notification method than Polling');
  }

  getWaitOnBankAccountAnalysisCompletionNotificationGateway(): WaitOnBankAccountAnalysisCompletionGateway {
    if (this.notificationMethodToUse === 'POLLING') {
      return this.waitOnBankAccountAnalysisCompletionViaPolling;
    }

    throw new Error('There is no other notification method than Polling');
  }
}
